import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-product-detail',
  templateUrl: './sponsor-product-detail.component.html',
  styleUrls: ['./sponsor-product-detail.component.sass']
})
export class SponsorProductDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
